import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=5911f005"
import script from "./MessageTemplate.vue?vue&type=script&lang=js"
export * from "./MessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=5911f005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports